import React from 'react';
import { Settings } from 'lucide-react';
import PermissionToggle from './PermissionToggle';
import type { ModuleRowProps } from '../../../../../types/groupModulePermissions';

const ModuleRow: React.FC<ModuleRowProps> = ({ module, onPermissionChange }) => {
  return (
    <tr className="module-row">
      <td className="module-details-cell">
        <div className="module-details">
          <div className="module-icon">
            <Settings size={16} />
          </div>
          <div className="module-info">
            <div className="module-name">
              {module.name}
            </div>
          </div>
        </div>
      </td>
      <td className="permission-cell">
        <PermissionToggle
          checked={module.permissions.create}
          onChange={(checked) => onPermissionChange(module.id, 'create', checked)}
        />
      </td>
      <td className="permission-cell">
        <PermissionToggle
          checked={module.permissions.read}
          onChange={(checked) => onPermissionChange(module.id, 'read', checked)}
        />
      </td>
      <td className="permission-cell">
        <PermissionToggle
          checked={module.permissions.update}
          onChange={(checked) => onPermissionChange(module.id, 'update', checked)}
        />
      </td>
      <td className="permission-cell">
        <PermissionToggle
          checked={module.permissions.delete}
          onChange={(checked) => onPermissionChange(module.id, 'delete', checked)}
        />
      </td>
    </tr>
  );
};

export default ModuleRow;